import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import initI18n from "./scripts/i18n";
import initVisitStats from "./scripts/visitStats";
import initHeroContactForm from "./scripts/heroContactForm";
import yslImage from "./assets/friends/ysl.jpg";

function isYinshenglinPage() {
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
  return pathname === "/yinshenglin";
}

function renderYinshenglinPage() {
  document.documentElement.lang = "zh";
  document.title = "Shenglin Yin";

  document.body.innerHTML = `
    <main class="yinshenglin-page">
      <img src="${yslImage}" alt="Shenglin Yin" class="yinshenglin-page__image" />
      <div class="yinshenglin-page__panel">
        <div class="yinshenglin-page__info">
          <p class="yinshenglin-page__status">单身！</p>
          <p>email 📧: <a href="mailto:yinsl@stu.pku.edu.cn">yinsl@stu.pku.edu.cn</a></p>
        </div>
        <div class="yinshenglin-message-card">
          <p class="yinshenglin-message-card__title">留言板</p>
          <form id="hero-message-form" class="yinshenglin-form" novalidate>
            <div class="yinshenglin-form__row">
              <input
                type="text"
                name="name"
                maxlength="80"
                class="yinshenglin-form__input"
                placeholder="你的名字（可选）"
              />
              <input
                type="email"
                name="email"
                maxlength="120"
                class="yinshenglin-form__input"
                placeholder="你的邮箱（可选）"
              />
            </div>
            <textarea
              name="message"
              required
              maxlength="1200"
              class="yinshenglin-form__textarea"
              rows="4"
              placeholder="留言内容"
            ></textarea>
            <input type="text" name="website" class="yinshenglin-form__honeypot" tabindex="-1" autocomplete="off" aria-hidden="true" />
            <div class="yinshenglin-form__actions">
              <span id="hero-message-status" class="yinshenglin-form__status" aria-live="polite"></span>
              <button type="submit" class="yinshenglin-form__submit">发送</button>
            </div>
          </form>
        </div>
      </div>
    </main>
  `;

  const style = document.createElement("style");
  style.textContent = `
    body {
      margin: 0;
      background: #f7f7f2;
    }
    .yinshenglin-page {
      min-height: 100vh;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding: 2rem;
      box-sizing: border-box;
      background: radial-gradient(circle at 20% 20%, #ffffff 0%, #f7f7f2 55%, #ece9de 100%);
    }
    .yinshenglin-page__image {
      width: min(92vw, 980px);
      max-height: 88vh;
      object-fit: contain;
      border-radius: 12px;
      box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
      background: #fff;
    }
    .yinshenglin-page__panel {
      position: fixed;
      right: 2rem;
      bottom: 2rem;
      width: min(36rem, calc(100vw - 4rem));
      padding: 1.1rem 1.2rem;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.9);
      border: 1px solid rgba(0, 0, 0, 0.08);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      color: #222;
      backdrop-filter: blur(6px);
    }
    .yinshenglin-page__info {
      font-size: 1.7rem;
      line-height: 1.5;
    }
    .yinshenglin-page__status {
      color: #d70000;
      font-weight: 800;
    }
    .yinshenglin-page__info p {
      margin: 0;
    }
    .yinshenglin-page__info p + p {
      margin-top: 0.5rem;
    }
    .yinshenglin-page__info a {
      color: #0a66c2;
      text-decoration: none;
    }
    .yinshenglin-page__info a:hover {
      text-decoration: underline;
    }
    .yinshenglin-message-card {
      margin-top: 1rem;
      border-top: 1px solid rgba(0, 0, 0, 0.08);
      padding-top: 0.9rem;
    }
    .yinshenglin-message-card__title {
      margin: 0 0 0.7rem;
      font-size: 1.5rem;
      font-weight: 700;
      color: #222;
    }
    .yinshenglin-form__row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.6rem;
      margin-bottom: 0.6rem;
    }
    .yinshenglin-form__input,
    .yinshenglin-form__textarea {
      width: 100%;
      border: 1px solid #d7dce3;
      border-radius: 8px;
      padding: 0.8rem 0.9rem;
      font-size: 1.4rem;
      line-height: 1.4;
      background: #fff;
      color: #222;
      box-sizing: border-box;
    }
    .yinshenglin-form__textarea {
      resize: vertical;
      min-height: 8.8rem;
    }
    .yinshenglin-form__input:focus,
    .yinshenglin-form__textarea:focus {
      outline: none;
      border-color: #02aab0;
      box-shadow: 0 0 0 3px rgba(2, 170, 176, 0.15);
    }
    .yinshenglin-form__honeypot {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      border: 0 !important;
    }
    .yinshenglin-form__actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.8rem;
      margin-top: 0.7rem;
    }
    .yinshenglin-form__status {
      min-height: 1.8rem;
      font-size: 1.2rem;
      color: #4b5563;
      flex: 1 1 auto;
    }
    .yinshenglin-form__status.is-error {
      color: #c62828;
    }
    .yinshenglin-form__status.is-success {
      color: #0f8b4c;
    }
    .yinshenglin-form__submit {
      border: 0;
      border-radius: 999px;
      padding: 0.75rem 1.2rem;
      font-size: 1.35rem;
      font-weight: 700;
      color: #fff;
      cursor: pointer;
      background: linear-gradient(135deg, #02aab0, #00cdac);
      box-shadow: 0 6px 16px rgba(2, 170, 176, 0.25);
    }
    .yinshenglin-form__submit:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
    @media (max-width: 768px) {
      .yinshenglin-page {
        padding: 1.2rem;
        align-items: flex-start;
        flex-direction: column;
      }
      .yinshenglin-page__image {
        width: 100%;
        max-height: none;
        margin-bottom: 1rem;
      }
      .yinshenglin-page__panel {
        position: static;
        width: 100%;
        margin: 0;
        box-sizing: border-box;
      }
      .yinshenglin-page__info {
        font-size: 1.6rem;
      }
      .yinshenglin-form__row {
        grid-template-columns: 1fr;
      }
    }
  `;
  document.head.appendChild(style);
  initHeroContactForm();
}

if (isYinshenglinPage()) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderYinshenglinPage, { once: true });
  } else {
    renderYinshenglinPage();
  }
} else {
  // 初始化多语言（必须在其他模块之前）
  initI18n();

  // 等待 DOM 和 i18n 初始化完成
  document.addEventListener("DOMContentLoaded", () => {
    // 延迟一点确保 i18n 已经更新了页面
    setTimeout(() => {
      initScrollReveal(targetElements, defaultProps);
      initTiltEffect();
      initVisitStats();
      initHeroContactForm();
    }, 100);
  });

  // 如果 DOM 已经加载完成
  if (document.readyState !== "loading") {
    setTimeout(() => {
      initScrollReveal(targetElements, defaultProps);
      initTiltEffect();
      initVisitStats();
      initHeroContactForm();
    }, 100);
  }
}
